import { V004Algorithm } from '../../../../Algorithm';
import { V004AsymmetricCiphertextPrefix } from '../../V004AlgorithmTypes';
import { CreateConsistentBase64JsonPayloadUseCase } from '../Utils/CreateConsistentBase64JsonPayload';
export class AsymmetricEncrypt004 {
    constructor(crypto) {
        this.crypto = crypto;
        this.base64DataUsecase = new CreateConsistentBase64JsonPayloadUseCase(this.crypto);
    }
    execute(dto) {
        const nonce = this.crypto.generateRandomKey(V004Algorithm.AsymmetricEncryptionNonceLength);
        const ciphertext = this.crypto.sodiumCryptoBoxEasyEncrypt(dto.stringToEncrypt, nonce, dto.recipientPublicKey, dto.senderKeyPair.privateKey);
        const additionalData = {
            signingData: {
                publicKey: dto.senderSigningKeyPair.publicKey,
                signature: this.crypto.sodiumCryptoSign(ciphertext, dto.senderSigningKeyPair.privateKey),
            },
            senderPublicKey: dto.senderKeyPair.publicKey,
        };
        const components = [
            V004AsymmetricCiphertextPrefix,
            nonce,
            ciphertext,
            this.base64DataUsecase.execute(additionalData),
        ];
        return components.join(':');
    }
}
